<template>
  <div class="shipping-methods">
    <div v-if="shippingMethods.Warnings && shippingMethods.Warnings.length">
      <p
        v-for="warning in shippingMethods.Warnings"
        :key="warning"
      >
        {{ warning }}
      </p>
    </div>
    <div v-if="shippingMethods.ShippingMethods && shippingMethods.ShippingMethods.length">
      <SfRadio
        v-for="shipping in shippingMethods.ShippingMethods"
        :key="shipping.Name"
        :label="shipping.Name"
        :details="currencyFormatter().format(shipping.Fee)"
        :description="shipping.Description"
        name="ShippingMethod"
        :value="shipping.Name"
        :required="true"
        v-model="shippingMethod"
        @input="handleInputChange(shipping)"
      />
    </div>
  </div>
</template>
<script>
import {
  SfRadio,
} from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'ShippingMethods',
  mixins: [config],
  components: {
    SfRadio,
  },
  props: {
    shippingMethods: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({
        name: '',
        system: '',
      }),
    },
  },
  data() {
    return {
      shippingMethod: '',
    };
  },
  methods: {
    handleInputChange(data) {
      this.$emit('input', {
        name: data.Name,
        system: data.ShippingRateComputationMethodSystemName,
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.shippingMethod = this.value.name;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>

.sf-button,
.sf-input,
.sf-checkbox {
  margin-bottom: var(--spacer-sm);
}

</style>
